import API from '../dataApi';

// -- Derasar -------------------------------------------------------------------
export const getPublicDerasars = () => API.get('/derasar/public/list');
export const getPublicDerasar = (id) => API.get(`/derasar/public/${id}`);
export const getDerasars = () => API.get('/derasar');
export const getDerasar = (id) => API.get(`/derasar/${id}`);
export const createDerasar = (data) => API.post('/derasar', data);
export const joinDerasar = (id) => API.post(`/derasar/${id}/join`);
export const requestDerasarRenewal = (id) => API.post(`/derasar/${id}/request-renewal`);
export const approveDerasarMember = (derasarId, userId, action) =>
  API.put(`/derasar/${derasarId}/approve/${userId}`, { action });
export const updateDerasar = (id, data) => API.put(`/derasar/${id}`, data);
export const deleteDerasar = (id) => API.delete(`/derasar/${id}`);
export const deleteDerasarMembership = (id) => API.delete(`/derasar/${id}/membership`);
export const updateOnlinePaymentBank = (id, data) => API.put(`/derasar/${id}/online-payment-bank`, data);
